module.exports = __webpack_public_path__ + "img/mail.8d1a5ad2.svg";